// extracted by mini-css-extract-plugin
export default {"CoursesBox":"Courses_CoursesBox__dVDX4","CourseImg":"Courses_CourseImg__6iqQm"};